/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Header/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import BlockTime from './BlockTime/index'
import No from './No/index'
import Note from './Note/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Header({
  children,
  viewPath = "/DesignSystem/TimegridScheduleNote/Header"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let scheduleNoteTypeValueData = fromData.useDataValue({ viewPath,
context: 'schedule_note',
path: 'type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: scheduleNoteTypeValueData,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Header.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-Z2wmEtq': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--g-2-Z2wmEtq': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Note'}>
<Note
  viewPath={`${viewPath}/Note`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'BlockTime'}>
<BlockTime
  viewPath={`${viewPath}/BlockTime`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}